import {
  Fact,
  LedgerHoverCard,
  RefCode,
  StatusWord,
  formatLedgerWhenFull,
  statusToken,
} from '../../../shared/components/ledger';
import type { VariationLedgerRowModel } from './toVariationRows';

interface VariationHoverCardProps {
  row: VariationLedgerRowModel;
  onOpenDetails: () => void;
}

/**
 * The row hover card: a shortcut to the variation panel, and where the facts
 * the row demotes or truncates reappear — the free-text entry in full first.
 *
 * There is no value fact: the org-wide variations feed projects no money.
 * Approved by / rejected by / rejection reason are missing for the same
 * reason — the card omits a fact it can't source rather than firing a second
 * query to fill it in.
 */
export function VariationHoverCard({
  row,
  onOpenDetails,
}: VariationHoverCardProps) {
  return (
    <LedgerHoverCard
      title={row.workTypeName}
      kind="Variation"
      description={row.description}
      onOpenDetails={onOpenDetails}
    >
      <Fact label="Status">
        <StatusWord token={statusToken(row.status)} />
      </Fact>
      {row.reference && (
        <Fact label="Ref">
          <RefCode>{row.reference}</RefCode>
        </Fact>
      )}
      <Fact label="Site · Plot">{`${row.sitePlot.site} · ${row.sitePlot.plot}`}</Fact>
      <Fact label="Booked by">{row.bookedBy}</Fact>
      <Fact label="When">{formatLedgerWhenFull(row.bookedAt)}</Fact>
    </LedgerHoverCard>
  );
}
